import './App.css';
import { createBrowserRouter, createRoutesFromElements, Navigate, Route, RouterProvider } from 'react-router-dom';
import { GlobalWrapper } from './common/pages/GlobalWrapper';
import { WhiteboardPage } from './pages/WhiteboardPage';
import { useEffect } from 'react';
import { getParameter, Parameter } from './common/helpers/parameters';
import { sdkClient } from './common/helpers/sdk';
import { setTokens } from './features/main/mainSlice';
import { useAppDispatch } from './app/hooks';
import { logout } from './features/main/extraActions';
import { KastAppClientForbiddenType } from '@kalyzee/kast-web-sdk/http';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<GlobalWrapper />} errorElement={<Navigate to='' />}>
      <Route path='' element={<WhiteboardPage />} />
    </Route>
  )
);

function App() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const token = getParameter(Parameter.Token)?.value;
    const refreshToken = getParameter(Parameter.RefreshToken)?.value;
    const clientTokens = {
        token,
        refreshToken,
    }
    if (clientTokens.token) {
      sdkClient.authenticateHttpClient({ method: { type: "tokens", data: clientTokens } }).then((result) => {
        if (!result) dispatch(logout())
      }).catch((err) => {
        console.log("Error catched: ", err)
        dispatch(logout())
      });
    }

    const httpClient = sdkClient.getHttpClient();
    httpClient.addEventListener('tokenRefresh', (tokens) => {
      if (!tokens) return;
      dispatch(setTokens(tokens));
    });
    httpClient.addEventListener('tokenExpire', () => {
      dispatch(logout());
    });
    httpClient.addEventListener('forbidden', (type: KastAppClientForbiddenType) => {
      console.log("Forbiden")
      dispatch(logout());
    });
  }, []);

  return <RouterProvider router={router} />
}

export default App;
